import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { useTimezoneDate } from '@mwl/core-lib';
import { lineRowLinkDataAttributes } from '@/constants';
import { SportClock } from '../SportClock/SportClock';
import type { MatchStatusProps } from './MatchStatus.types';
import styles from './MatchStatus.module.scss';
export const MatchStatus: FC<MatchStatusProps> = ({
  className,
  currentSegment,
  stage,
  status,
  beginAt,
  dateFormat = 'HH:mm dd.MM',
  clock,
  isMatchEnded,
  ...props
}) => {
  const {
    t
  } = useTranslation('sport');
  const {
    value: localBeginAt
  } = useTimezoneDate({
    date: beginAt,
    format: dateFormat
  });
  const [localBeginAtTime, localBeginAtDate] = localBeginAt.split(' ');
  return <div className={cn(styles.root, className, {
    [styles.ended]: isMatchEnded
  })} {...props} {...lineRowLinkDataAttributes} data-sentry-component="MatchStatus" data-sentry-source-file="MatchStatus.tsx">
      {(!!clock?.time || !currentSegment && beginAt) && !isMatchEnded && <div className={cn(styles.time, styles[stage.toLowerCase()])}>
          {!!clock?.time && <SportClock clock={clock} status={status} stage={stage} />}
          {!currentSegment && !clock?.time && beginAt && localBeginAtTime}
        </div>}
      <p className={styles.status} {...lineRowLinkDataAttributes}>
        {stage === 'PREGAME' && !isMatchEnded && localBeginAtDate}
        {stage === 'LIVE' && !isMatchEnded && (currentSegment ?? null)}
        {isMatchEnded && t('match_ended', 'Match ended')}
      </p>
    </div>;
};